// extracted by mini-css-extract-plugin
module.exports = {"paginationWrapper":"_8b127e4","pagination":"_3539958","inactiveDot":"_2c6bf94","clickable":"_df412f2"};